import { useEffect } from 'react';

/**
 * Verhindert, dass ein Datei-Drop, der ein Upload-Ziel verfehlt, die Datei im Browser-Tab öffnet
 * (Standard-Verhalten des Browsers). Greift nur für echte Datei-Drags (`Files`-Typ).
 */
export function useFileDropGuard() {
  useEffect(() => {
    const guard = (e: DragEvent) => {
      if (Array.from(e.dataTransfer?.types ?? []).includes('Files')) e.preventDefault();
    };
    window.addEventListener('dragover', guard);
    window.addEventListener('drop', guard);
    return () => {
      window.removeEventListener('dragover', guard);
      window.removeEventListener('drop', guard);
    };
  }, []);
}
